import LazyloadImg from '../class/LazyloadImg';
import Tooltip from '../class/Tooltip';
import GuideFinder from '../class/GuideFinder';
import ProductSingleSlider from "../class/ProductSingleSlider";
import {SuperAlign} from "../class/SuperAlign";
import SimpleImageSlider from "../class/SimpleImageSlider";
import OverviewProducts from "../class/OverviewProducts";

new Tooltip('.tooltip-custom', '/ajax/feature_benefits.php').init()

new LazyloadImg('.lazy-load-img', 'data-listener-lazy-id', 'data-img-id').init()

new GuideFinder('.guide-finder', {
  guideFinderMakeSelector: '#guide-finder-make',
  guideFinderYearSelector: '#guide-finder-year',
  guideFinderModelSelector: '#guide-finder-model',
  guideFinderTrimSelector: '#guide-finder-trim',
  guideFinderConnectionSelector: '#guide-finder-connection',
  guideFinderInstallTypeSelector: '#guide-finder-install-type',
  guideFinderDeviceSelector: '#guide-finder-device',
  guideFinderResetSelector: '#reset-guide-finder',
  guideFinderSelectSelector: '.guide-search-dropdown',
  guideFinderInputSearchSelector: '#guide_number',
  guideFinderBtnSearchSelector: '#searchByNumberBtn',
  guideFinderGuideIdSelector: 'data-guide-id',
  guideFinderProductIdSelector: 'data-product-id',
  guideFinderProductIdTag: 'h1'

}, {
  yearsByMake: '/ajax/years_by_make.php',
  makesByYears: '/ajax/makes_by_year.php',
  modelsByMakeYear: '/ajax/models_by_make_year.php',
  trimsByMakeModelYear: '/ajax/trims_by_make_model_year.php',
  guides: '/ajax/guides.php'
}).init();


$(".js-swiper-product-loop").each(function(){
  let id = $(this).attr('data-id');
  new SuperAlign('.js-text-normalize-'+id).init();
  new ProductSingleSlider(
    '.js-swiper-product-slider-'+id,
    id
  ).init();
});



$(".js-simple-image-slider-loop").each(function(){
  let id = $(this).attr('data-id');
  new SimpleImageSlider(
    '.js-simple-image-slider-1'
  ).init();
});

const superAlign = new SuperAlign('.js-text-normalize-features', {
  diveType: 'complex'
});
superAlign.init();





$('.product-wrapper').on('click', function (ev) {
  if (!$.contains($(ev.target).closest('.js-product-items').find('.actions')[0], ev.target) &&
    !$.contains($(ev.target).closest('.js-product-items').find('.mobile-actions')[0], ev.target) &&
    (!$(ev.target).hasClass('js-goToProduct'))
  ) {
    window.location.href = $(ev.target).closest('.js-product-items').find('a.btn.product').attr('href');
  }
})
